
<h1>{{tipo=='edit' ? 'Editar' : 'Agregar'}} Sucursal</h1>
<form [formGroup]="form" (submit)="submit()" class="form-horizontal" novalidate>
  <fieldset>

    <div *ngIf="tipo=='save'" class="form-group"  [ngClass]="{'has-error': (form.get('id_planta').touched || form.get('id_planta').dirty) && !form.get('id_planta').valid }">
      <label class="col-md-2 control-label" for="nombre">ID Planta</label>
      <div class="col-md-8">
        <input class="form-control" id="id_planta" type="text" required   formControlName="id_planta"  />
        <span class="alert alert-danger" *ngIf="(form.get('id_planta').touched || form.get('id_planta').dirty) && form.get('id_planta').errors">
          <span *ngIf="form.get('id_planta').errors.required">
            El campo ID Planta es requerido
          </span>
        </span>
      </div>
    </div>

    <div class="form-group"  [ngClass]="{'has-error': (form.get('nom_planta').touched || form.get('nom_planta').dirty) && !form.get('nom_planta').valid }">
      <label class="col-md-2 control-label" for="nombre">Nombre</label>
      <div class="col-md-8">
        <input class="form-control" id="nom_planta" type="text" required   formControlName="nom_planta" />
        <span class="alert alert-danger" *ngIf="(form.get('nom_planta').touched || form.get('nom_planta').dirty) && form.get('nom_planta').errors">
          <span *ngIf="form.get('nom_planta').errors.required">
            El campo nombre es requerido
          </span>
        </span>
      </div>
    </div>




    <div class="form-group">
      <div class="col-md-4 col-md-offset-2">
        <span>
          <button class="btn btn-primary"   [disabled]="!form.valid"> Salvar  </button>
          <button class="btn btn-primary" (click)="closeMyModal(false)">Cerrar Modal</button>

        </span>

      </div>

    </div>
  </fieldset>
</form>
